import React, { useEffect, useRef, useState } from "react";
import { useProductDispatch } from "../../stores/product/product.store";
import { gtag } from "../../stores/product/product.reducer";
import { CharacteristicsInterface } from "../../interfaces/product/product.interface";

interface CharacteristicsProps {
    characteristics: CharacteristicsInterface[];
}

export const Characteristics: React.FC<CharacteristicsProps> = ({ characteristics }) => {
    const ref = useRef<HTMLDivElement>(null);
    const [, setIsVisible] = useState(false);
    const dispatch = useProductDispatch();

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsVisible(true);
                        dispatch(gtag('mn_characteristics_full_view'))
                        observer.disconnect(); // Отключаем наблюдатель после срабатывания
                    }
                });
            },
            {
                threshold: 0.1, // Часть элемента, которая должна быть видна (0.1 означает 10% видимости)
            }
        );

        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => {
            if (ref.current) {
                observer.unobserve(ref.current);
            }
        };
    }, []);

    return (
        <div className="grid md:grid-cols-2 md:gap-y-4 md:gap-x-14 gap-x-4">
            { characteristics.map((c,i) => <div key={ i } className="grid grid-cols-2 gap-4">
                <span className="text-[14px] text-gray">{ c.name }</span>
                <span className="text-[14px] ">{ c.value }</span>
            </div>) }
        </div>
    )
}